import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { configs } from '../../../assets/Config';
import { useLogin } from '../../../services/contexts/AdminLoginContext';
import LeftBarPage from '../../includes/dashboard/LeftBarPage';
import TopBarPage from '../../includes/dashboard/TopBarPage';
import ToastPage from '../../includes/ToastPage';
import '../../../assets/styles/RM.css'
import { useCouponContext } from '../../../services/contexts/couponManagement/CouponContext';
import ListCouponPage from './ListCouponPage';
// import CreateCouponPage from './CreateCouponPage';
import DeletedCouponPage from './DeletedCouponPage';
import CreateCouponPage from './CreateCouponPage';


export default function CouponMainPage() {

    const { couponList, getAllcouponList, showDeletedcoupon } = useCouponContext()
    const { setCurrModule, allowedFunc } = useLogin()

    const history = useHistory()

    useEffect(() => {
        (async () => {
            try {
                if (allowedFunc.includes(configs.functionList['coupon_management:coupon_management'])) {
                    setCurrModule(configs.modules.couponMgmt)
                    getAllcouponList()
                } else {
                    return history.goBack()
                }
            } catch (error) {

            }
        })()
    }, [])

    // role management main ui code
    return (
        <>
            <TopBarPage />
            <div style={{ display: "flex" }}>
                <LeftBarPage />
                {showDeletedcoupon ? <div id='rmContainer' className="rm-container"><DeletedCouponPage /></div> :
                    <div id='rmContainer' className="rm-container">
                        <ListCouponPage />
                        {allowedFunc.includes(configs.functionList['coupon_management:coupon_management']) ?
                            <CreateCouponPage />
                            : null}
                        <ToastPage />
                    </div>
                }
            </div>
        </>
    )
}